var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useEffect, useRef, useState } from 'react';
import withDesign from '../../../hocs/withDesign';
import { TranslatedText } from '../TranslatedText';
import { FakeLink, Text, Wrapper } from './styles';
export var TruncateCompoment = function (_a) {
    var design = _a.design, children = _a.children, schema = _a.schema, readMore = _a.readMore, readLess = _a.readLess;
    var _b = useState(true), isTruncated = _b[0], setIsTruncated = _b[1];
    var _c = useState(true), isExpandable = _c[0], setIsExpandable = _c[1];
    var ref = useRef();
    useEffect(function () {
        if (ref.current) {
            var element = ref.current;
            var isOverflow = element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;
            setIsExpandable(isOverflow);
            setIsTruncated(isOverflow);
        }
    }, []);
    var handleExpand = function () {
        setIsTruncated(!isTruncated);
    };
    return (_jsxs(Wrapper, __assign({ "data-design": design, schema: schema }, { children: [_jsx(Text, __assign({ isTruncated: isTruncated, ref: ref, className: "truncate__text" }, { children: children })), isExpandable &&
                (isTruncated ? (_jsx(FakeLink, __assign({ role: "button", onClick: handleExpand, className: "truncate__fakeLink" }, { children: _jsx(TranslatedText, { i18n: readMore }) }))) : (_jsx(FakeLink, __assign({ role: "button", onClick: handleExpand, className: "truncate__fakeLink" }, { children: _jsx(TranslatedText, { i18n: readLess }) }))))] })));
};
export var Truncate = withDesign(TruncateCompoment);
